import React, { createContext, useContext, useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import { EventService } from "../Services/event.service";

const EventContext = createContext(null);

// Mock data pour développement uniquement (id = "test")
const MOCK_EVENT = {
  dates: [
    { id: "1", value: "Samedi 15 Février 2025" },
    { id: "2", value: "Dimanche 16 Février 2025" },
    { id: "3", value: "Samedi 22 Février 2025" },
  ],
  generalImage: "",
  locationName: "Magasin Test",
  locationZip: "75001",
  locationStreet: "123 Rue de Test",
  locationCityName: "Paris",
  locationDetails: "Lundi - Samedi : 9h - 19h",
  gifts: [
    { title: "Cadeau 1", description: "Description du cadeau 1", imageUrl: "" },
    { title: "Cadeau 2", description: "Description du cadeau 2", imageUrl: "" },
  ],
  rouletteImage: "",
};

export const EventProvider = ({ children }) => {
  const { id } = useParams();
  const location = useLocation();

  const [event, setEvent] = useState(null);
  const particule = new URLSearchParams(location.search).get("particule");
  const showGenderLabels = particule === "1";

  useEffect(() => {
    const fetchEvent = async () => {
      // En dev, si id === "test", utiliser les mock data
      if (process.env.NODE_ENV === "development" && id === "test") {
        setEvent(MOCK_EVENT);
        return;
      }
      const event = await EventService.fetchEvent(id);
      setEvent(event);
    }
    if (id) {
      fetchEvent(id);
    }
  }, [id]);

  return (
    <EventContext.Provider value={{ event , eventId : id, showGenderLabels }}>
      {children}
    </EventContext.Provider>
  );
};

export const useEvent = () => useContext(EventContext);
